{
  "CSAT": {
    "TITLE": "به مکالمه خود امتیاز دهید",
    "PLACEHOLDER": "توضیحات بیشتر بدهید...",
    "RATINGS": {
      "POOR": "😞 خیلی بد",
      "FAIR": "😑 بد",
      "AVERAGE": "😐 معمولی",
      "GOOD": "😀 خوب",
      "EXCELLENT": "😍 عالی"
    }
  }
}
